import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRolePermission, rolePermissionsSelector, updateUISection} from '../../../store/slices/rolePermissions';
import { useExpanded, useTable } from 'react-table';
import _ from 'lodash'
import { Checkbox, FormControl, MenuItem, Select, useTheme } from '@mui/material';
import { convertArrayToDictionary } from '../../../common/utils';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditIcon from '@mui/icons-material/Edit';
import RolePermissionsEditDialog from './rolePermissionsEditDialog';
const  accessLevelColor = {0:'gray', 3:"#458EF4", 2: "#67d000", 1:"#f09b00"}
const NestedTable = ({ data, level = 0,  rolePermissions}) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [accessLevel, setAccessLevel] = useState({})
  // const { rolePermissions } = useSelector(rolePermissionsSelector);

  const dispatch = useDispatch();

  useEffect(()=>{
    const accessLevelMap  = {};
    data.forEach((item)=>{
       accessLevelMap[item.uiSectionId]= item.accessLevel 
    })
    setAccessLevel(accessLevelMap)
  },[data]);
  const handleAccesslevelChange = (value, row)=>{ 
          dispatch(updateUISection({uiSectionId:row.uiSectionId, accessLevel:value}));
       
  }

  const columns = React.useMemo(() => [
    
    // const keys = data?.length ? Object.keys(data[0]).filter(key => key !== 'children') : [];
    // return keys.map((key) => ({
    //   Header: key.charAt(0).toUpperCase() + key.slice(1),
    //   accessor: key,
    // }));

  {
    Header: 'Name',
    accessor: 'name',
     Cell: ({ row, value }) => {
        const hasChildren = row.original.children?.length > 0;
        return (
          <div {...(hasChildren ? row.getToggleRowExpandedProps() : {})} style={{ cursor: hasChildren ? 'pointer' : 'default', paddingLeft: `${level * 20}px`, display:'flex', alignItems:'center', gap:'5px' }} >
            <span>{value}</span>
            {hasChildren ? (row.isExpanded ? <KeyboardArrowDownIcon/> : <KeyboardArrowUpIcon/>) : ''}
          </div>
        );
      },
  },
  {
    Header: 'Accesslevel',
    accessor: 'accessLevel',
    Cell: ({ row }) => {
        return(
            <>
              <FormControl >
               
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={row.original.accessLevel??0}
                  onChange={(e)=>{ const value = e.target.value;  
                    handleAccesslevelChange(value, row.original) 
                  }}
                  sx={{background:accessLevelColor[row.original.accessLevel ?? 0], 
                    width:'120px', border:'0 !important', 
                    '&:hover':{border:'0 !important'}, 
                    '& .MuiSelect-select':{padding:'4px 8px',paddingRight:'8px !important', width:'120px', fontSize:'14px', color:'#fff', textAlign:'center'},
                    '&.MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'transparent', 
                          },
                          '&:hover fieldset': {
                            borderColor: 'transparent',
                          },
                          
                        }
                  }}
                  IconComponent={''}
                >
                  <MenuItem value={0} sx={{color:'gray'}}>None</MenuItem>
                  <MenuItem value={1} sx={{color:'#f09b00'}}>Dev</MenuItem>
                  <MenuItem value={2} sx={{color:'#67d000'}}>Beta</MenuItem>
                  <MenuItem value={3} sx={{color:'#458EF4'}}>Public</MenuItem>
                </Select>
              </FormControl>
            </>
        )
    },
  },
  {
    Header: 'User',
    accessor: 'user',
    Cell: ({ row }) => {
      
        return(
            <><Checkbox checked={row?.original?.isUser} sx={{padding:'0'}}/></>
        )
    },
  },
  {
    Header: 'Admin',
    accessor: 'admin',
    Cell: ({ row }) => {
        return(
            <><Checkbox checked={row?.original?.isAdmin} sx={{padding:'0'}}  /></>
        )
    },
  },
  {
    Header: 'Manager',
    accessor: 'manager',
    Cell: ({ row }) => {
        return(
            <><Checkbox checked={row?.original?.isManager} sx={{padding:'0'}}  /></>
        )
    },
  },
   {
    Header: '',
    accessor: 'uiSectionId',
    Cell: (row) => {
        return(
            <>
              <EditIcon sx={{padding:'0'}} onClick={()=>{setOpenEdit(true); setSelectedRow(row.row.original);}} style={{cursor:'pointer'}}/>
            </>
        )
    },
  },
    
], [data, rolePermissions]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        expanded: data?.reduce((acc, _, index) => {
          acc[index] = true; 
          return acc;
        }, {}),
      },
    },
    useExpanded
  );


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  const handleClose = ()=>{
    setOpenEdit(false);
  }
  return (<>
    <table
      {...getTableProps()}
      
      style={{
        borderCollapse: 'collapse',
        width: '100%',
        // marginLeft: `${level * 20}px`,
        // background: level > 0 ? '#f9f9f9' : '#fff',
         tableLayout: 'fixed', 
      }}
      className='rolePermissonTable'
    >
     {level===0&& <thead>
        {headerGroups.map((group) => (
          <tr {...group.getHeaderGroupProps()} style={{ background: '#eff4fa' }}>
            {group.headers.map((col) => (
              <th {...col.getHeaderProps()}>{col.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>}
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          const hasChildren = row.original.children?.length > 0;
          return (
            <React.Fragment key={row.original.uiSectionId}>
              <tr {...row.getRowProps()} style={{background: hasChildren?'#dce7f4':'#fff'}}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()} style={{fontWeight: hasChildren?'600':'normal'}}>{cell.render('Cell')}</td>
                ))}
              </tr>
              {hasChildren && row.isExpanded && (
                <tr style={{background:'#dce7f4'}}>
                  <td colSpan={columns.length} style={{padding:0}}>
                    <NestedTable data={row.original.children} level={level + 1} rolePermissions={rolePermissions}/>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
   {openEdit&&<RolePermissionsEditDialog open={openEdit} handleClose={handleClose} selectedRow={selectedRow}/>}
    </>
  );
};


const RolePermissions = () => {
  const dispatch = useDispatch();
  const {uiSections, roles, rolePermissions } = useSelector(rolePermissionsSelector);

  const roleDic = useMemo(()=>convertArrayToDictionary(roles, 'name'),[roles]);

  const getPermission = (uiSectionId, roleId)=>{
          return _.filter(rolePermissions, (it)=>it.uiSectionId===uiSectionId&&it.roleId===roleId)?.length===1?true:false
  }
  const uiSectionData = useMemo(() => {
  const data = [];

  const parents = _.filter(uiSections, item => item.parentId === null);
  const groupedByParent = _.groupBy(uiSections, item => item?.parentId);
  parents.forEach(parent => {
    const childItem = groupedByParent[parent?.uiSectionId] || [];
    const grandChild = childItem.map(child=>{
        const grandChildren = (groupedByParent[child.uiSectionId] || []).map(gc => ({
        ...gc,
        isAdmin: getPermission(gc?.uiSectionId, roleDic['Admin']?.roleId),
        isManager: getPermission(gc?.uiSectionId, roleDic['Manager']?.roleId),
        isUser: getPermission(gc?.uiSectionId, roleDic['User']?.roleId),
      }));
       return {
      ...child,
      children: _.orderBy(grandChildren, ['sequence']),
      isAdmin: getPermission(child?.uiSectionId, roleDic['Admin']?.roleId),
      isManager:  getPermission(child?.uiSectionId, roleDic['Manager']?.roleId), 
      isUser: getPermission(child?.uiSectionId, roleDic['User']?.roleId), 
    }})

    data.push({
      ...parent,
      children: _.orderBy(grandChild, 'sequence'),
      isAdmin: getPermission(parent?.uiSectionId, roleDic['Admin']?.roleId),
      isManager:  getPermission(parent?.uiSectionId, roleDic['Manager']?.roleId), 
      isUser: getPermission(parent?.uiSectionId, roleDic['User']?.roleId), 
    });
  });

  return _.orderBy(data, 'sequence');
}, [uiSections, rolePermissions]);


  useEffect(() => {
    dispatch(fetchRolePermission());
  }, [dispatch]);

  return (
    <div>
      <h2>Role Permissions</h2>
      {roles?.length ? (
        <NestedTable data={uiSectionData} rolePermissions={rolePermissions}/>
      ) : (
        <p>Loading or no data found.</p>
      )}
    </div>
  );
};

export default RolePermissions;









